module.exports = __webpack_public_path__ + "img/csl_vial.916db5a0.png";